import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useNavigate } from 'react-router-dom';

const pinIcon = L.divIcon({
  className: '',
  html:
    "<div style=\"transform:translate(-50%,-100%)\"><svg width='34' height='34' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M12 2C7.9 2 4.5 5.4 4.5 9.5c0 5.3 6.3 11.4 7 12.1.3.3.7.3 1 0 .7-.7 7-6.8 7-12.1C19.5 5.4 16.1 2 12 2z' fill='%23065F46' stroke='white' stroke-width='1.5'/><circle cx='12' cy='9.5' r='3' fill='%23D4AF37'/></svg></div>",
  iconSize: [34, 34],
});

const MosqueMap = ({ mosques = [], userPos = null }) => {
  const el = useRef(null);
  const map = useRef(null);
  const layer = useRef(null);
  const userLayer = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (map.current || !el.current) return;
    map.current = L.map(el.current, { scrollWheelZoom: false, attributionControl: true }).setView([-2.4, 118], 4.4);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap', maxZoom: 19,
    }).addTo(map.current);
    layer.current = L.layerGroup().addTo(map.current);
    setTimeout(() => map.current && map.current.invalidateSize(), 300);
  }, []);

  useEffect(() => {
    if (!map.current || !layer.current) return;
    layer.current.clearLayers();
    const pts = mosques.filter((m) => m.latitude != null && m.longitude != null);
    pts.forEach((m) => {
      const mk = L.marker([m.latitude, m.longitude], { icon: pinIcon });
      mk.bindTooltip(`${m.name} · ${m.village_name || ''}`, { direction: 'top' });
      mk.on('click', () => navigate(`/region/${m.regency_slug}/${m.village_slug}/${m.slug}`));
      mk.addTo(layer.current);
    });
    if (pts.length) {
      try {
        const fg = L.featureGroup(pts.map((m) => L.marker([m.latitude, m.longitude])));
        map.current.fitBounds(fg.getBounds().pad(0.4), { maxZoom: 12 });
      } catch (e) {}
    }
  }, [mosques, navigate]);

  useEffect(() => {
    if (!map.current || !userPos) return;
    if (userLayer.current) map.current.removeLayer(userLayer.current);
    const dot = L.circleMarker([userPos.lat, userPos.lng], {
      radius: 9, color: '#1d4ed8', fillColor: '#3b82f6', fillOpacity: 0.9, weight: 3,
    }).bindTooltip('Lokasi Anda', { direction: 'top' });
    userLayer.current = L.layerGroup([dot]).addTo(map.current);
    map.current.setView([userPos.lat, userPos.lng], 11, { animate: true });
  }, [userPos]);

  return (
    <div
      ref={el}
      data-testid="landing-map"
      style={{ height: '340px' }}
      className="rounded-3xl overflow-hidden border border-emerald-100 shadow-lg relative z-0"
    />
  );
};

export default MosqueMap;
